import React from 'react';
import { motion } from 'framer-motion';
import '../styles/LegalPages.css'; // CSS-Import

// Animations-Varianten für die Inhaltsblöcke
const sectionVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, ease: 'easeOut' }
  },
};

const ImpressumPage = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>

      {/* Stilvolle Kopfzeile */}
      <div className="legal-page-hero">
        <motion.h1 initial={{ y: -30 }} animate={{ y: 0 }} transition={{ duration: 0.5 }}>
          Impressum
        </motion.h1>
      </div>

      {/* Animierter Inhaltsbereich */}
      <div className="legal-content-wrapper">
        <motion.div 
          className="legal-section"
          variants={sectionVariants}
          initial="hidden"
          animate="visible"
        >
          <h3>Angaben gemäß § 5 TMG</h3>
          <p>
            Tobias Alexander Grimm<br />
            [Breisgaustraße 65]<br />
            [04209] Leipzig<br />
            Deutschland
          </p>
        </motion.div>

        <motion.div 
          className="legal-section"
          variants={sectionVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
        >
          <h3>Kontakt</h3>
          <p>
            Telefon: [017636090006]<br />
            E-Mail: [tobias.alexander.grimm@gmail.com]
          </p>
        </motion.div>

        <motion.div 
          className="legal-section"
          variants={sectionVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.4 }}
        >
          <h3>EU-Streitschlichtung</h3>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer"> https://ec.europa.eu/consumers/odr/</a>.
            <br />
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </motion.div>

        <motion.div 
          className="legal-section"
          variants={sectionVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.6 }}
        >
          <h3>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h3>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </motion.div>
      </div>

    </motion.div>
  );
};

export default ImpressumPage;